import { getUserInfo } from "api/auth.api";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";

import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import { resetEntireReportState } from "store/slices/reports.slice";
import { setSelectedProject } from "store/slices/searcSlice";
import { setUserData, setUserLoading } from "store/slices/user.slice";

const RouteChangeHandler = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [userLoggedInCount, setUserLoggedInCount] = useState(() => {
    return Number(localStorage.getItem("userLoggedInCount")) || 0;
  });
  const navigate = useNavigate();

  const navigationType = useNavigationType();
  const prevLocation = useRef<string | null>(null);
  const defaultSelectedProject = useAppSelector((state) => state.search.selectedProject);
  const version = useAppSelector((state) => state.user.userInformation.version);
  const queryParams = new URLSearchParams(location.search);
  const jobId = queryParams.get("job-id");
  const creditsChange = useSelector((state: any) => state.refresh.creditsRefresh);

  useEffect(() => {
    if (navigationType === "PUSH") {
      prevLocation.current = location.pathname;
    }
    if (location.pathname !== "/report-editor") {
      dispatch(resetEntireReportState());
    }
  }, [location, navigationType]);
  useEffect(() => {
    // Function to be called on every route change
    const handleRouteChange = () => {
      dispatch(setUserLoading(true));

      getUserInfo().then(
        (data) => {
          if (version && data.version !== version) {
            navigate("/logout");
          }
          
          if (
            location.pathname !== "/logout" &&
            location.pathname !== "/auth/login" &&
            location.pathname !== "/auth/login" &&
            location.pathname !== "/upgrade-plan" &&
            location.pathname !== "/resource-center" &&
            location.pathname !== "/report-list" &&
            location.pathname !== "/report-editor" &&
            location.pathname !== "/report-editor/" &&
            location.pathname !== "/projects/report-list/" &&
            (data.user_role === "EXTERNAL_CONTRIBUTOR" || location.pathname !== "/create-project") &&
            !location.pathname.startsWith("/user-project-list") && !location.pathname.startsWith("/projects/sort-candidates/")
          ) {
            const logCount = sessionStorage.getItem("logCount");

            if (data.user_role === "EXTERNAL_CONTRIBUTOR") {
              navigate("/user-project-list");
              return;
            }
            if (!data.is_project_available && logCount !== "1") {
              sessionStorage.setItem("logCount", "1");
              navigate("/resource-center");

              return;
            }
            if (!data.is_project_available && data.user_role !== "EXTERNAL_CONTRIBUTOR") {
              navigate("/create-project");
              return;
            } else {
              if (!jobId && !defaultSelectedProject?.id && !location.pathname.startsWith("/hr-flow"))
                dispatch(setSelectedProject(data.project_details));
            }
          }
          dispatch(
            setUserData({
              subscription: {
                is_active: false,
              },
              payment: {
                is_active: false,
              },
              appSettings: {
                is_active: false,
              },
              features: {
                is_active: false,
              },
              feature_list: data.feature_list,
              is_hr_flow: data?.is_hr_flow,
              generalInfo: {
                is_project_available: data.is_project_available,
                default_project_details: data.project_details,
                is_search_available: false,
                is_talent_pool_available: false,
                is_team_available: false,
                email_enabled: data.email_enabled ? data.email_enabled : false,
              },
              credits: {
                candidate_screening: data?.credits?.candidate_screening,
                email_integration: data.credits.email_integration,
                export_candidates: data.credits.export_candidates,
                total_candidate_screening_credits: data.credits.total_candidate_screening_credits,
                total_candidate_screening_credits_remaining:
                  data.credits.total_candidate_screening_credits_remaining,
                total_candidate_screening_credits_used:
                  data.credits.total_candidate_screening_credits_used,
              },
              total_credits: data.total_credits,
              total_credits_remaining: data.total_credits_remaining,
              // total_credits_used: data.its_used
              total_credits_used: data.total_credits_used,
              products: {
                product_id: data.product.product_id,
                product_name: data.product.product_name,
              },
              user_role: data.user_role,
              version: data.version,
            })
          );
        },
        (error) => {
          //   dispatch(
          //     setSelectedProject({
          //       id: 8,
          //       name: "Umashankar",
          //     })
          //   );
          dispatch(
            setUserData({
              subscription: {
                is_active: false,
              },
              payment: {
                is_active: false,
              },
              appSettings: {
                is_active: false,
              },
              features: {
                is_active: false,
              },
              is_hr_flow: false,
              feature_list: [],
              generalInfo: {
                is_project_available: false,
                default_project_details: {
                  id: 0,
                  name: "",
                },
                is_search_available: false,
                is_talent_pool_available: false,
                is_team_available: false,
              },
              products: {
                product_id: 0,
                product_name: "",
              },
            })
          );
          console.error(error);
        }
      )
        .finally(() => {
          // Set loading to false when the request is complete (success or error)
          dispatch(setUserLoading(false));
        });

      // Call your desired function here
    };

    handleRouteChange();
  }, [location, creditsChange]);

  return null; // This component does not render anything
};

export default RouteChangeHandler;
